export const getValueWithPath = (obj, path) => {
  const pathArray = path.split('.');
  let value = obj;

  pathArray.forEach(key => {
    if (value && (value[key] !== null || value[key] !== undefined))
      value = value[key];
    else value = undefined;
  });

  return value;
};
